import * as React from 'react';
import classNames from 'classnames';

// Utils
import { useTranslation } from 'react-i18next';
// Constants
import { SEARCH_BAR_RENTAL_LINK_TYPE } from '@toolkit/const/app';
// Actions
// Models
import { UserModel } from '@src/shared/src/models';
// Interfaces
// Components
import { Modal, Tab } from '@toolkit/ui';
import { ConciergeLink } from '@src/components/ConciergeLink';
// Styles
import '../styles/SearchBarConcierge.scss';
import {
  AirportShuttleIcon,
  CarRentalIcon,
  ConnectingAirportsIcon,
  DirectionsBoatIcon,
  GroupAddIcon,
  HotelIcon,
  LocalParkingIcon,
  SearchIcon,
} from '@toolkit/ui/icons';

declare const window: any;

type Props = {
  profile: UserModel;
};

const SearchBarConcierge: React.FC<Props> = (props) => {
  const { t } = useTranslation();
  const [isModalVisible, setIsModalVisible] = React.useState(false);

  const services = [
    {
      type: SEARCH_BAR_RENTAL_LINK_TYPE.MULTI_STOP,
      label: t('searchBarConcierge.title.multi_stop'),
      icon: <ConnectingAirportsIcon />,
      desc: t('searchBarConcierge.label.multi_stop'),
    },
    {
      type: SEARCH_BAR_RENTAL_LINK_TYPE.SHUTTEL,
      label: t('searchBarConcierge.title.transit'),
      icon: <AirportShuttleIcon />,
      desc: t('searchBarConcierge.label.transit'),
    },
    {
      type: SEARCH_BAR_RENTAL_LINK_TYPE.SPECIALHOTELS,
      label: t('searchBarConcierge.title.special_hotel'),
      icon: <HotelIcon />,
      desc: t('searchBarConcierge.label.special_hotel'),
    },
    {
      type: SEARCH_BAR_RENTAL_LINK_TYPE.AIRPORTPARKING,
      label: t('searchBarConcierge.title.airport_parking'),
      icon: <LocalParkingIcon />,
      desc: t('searchBarConcierge.label.airport_parking'),
    },
    {
      type: SEARCH_BAR_RENTAL_LINK_TYPE.RENTAL,
      label: t('searchBarConcierge.title.rental'),
      icon: <CarRentalIcon />,
      desc: t('searchBarConcierge.label.rental'),
    },
    {
      type: SEARCH_BAR_RENTAL_LINK_TYPE.FERRY,
      label: t('searchBarConcierge.title.ferry'),
      icon: <DirectionsBoatIcon />,
      desc: t('searchBarConcierge.label.ferry'),
    },
    {
      type: SEARCH_BAR_RENTAL_LINK_TYPE.GROUPTRAVEL,
      label: t('searchBarConcierge.title.group_travel'),
      icon: <GroupAddIcon />,
      desc: t('searchBarConcierge.label.group_travel'),
    },
    {
      type: SEARCH_BAR_RENTAL_LINK_TYPE.OTHER,
      label: t('searchBarConcierge.title.other'),
      icon: <SearchIcon />,
      desc: t('searchBarConcierge.label.other'),
    },
  ];

  return (
    <>
      <div className="lp-search-bar-concierge" onClick={() => setIsModalVisible(true)}>
        <div className="lp-search-bar-concierge-image" />
        <div className="lp-search-bar-concierge-inner">
          <Tab
            label={t('searchBarConcierge.title.service')}
            onClick={() => setIsModalVisible(true)}
          />
          <div className="lp-search-bar-concierge-desc">{t('searchBarConcierge.description')}</div>
        </div>
      </div>
      <Modal
        isOpen={isModalVisible}
        onClose={() => setIsModalVisible(false)}
        title={t('searchBarConcierge.title.service')}>
        {props.profile && (
          <div className="lp-search-bar-concierge-services">
            {props.profile.organization.isDemo && (
              <div className="deactivated-message">
                {t('searchBarConcierge.demoDisabledMessage.text')}
              </div>
            )}
            {services.map((service, index) => (
              <ConciergeLink
                className={classNames('lp-search-bar-concierge-item', {
                  'lp-search-bar-concierge-item-disabled': props.profile.organization.isDemo,
                })}
                key={`concierge-link-${index}`}
                formType={service.type}>
                <div className="lp-search-bar-concierge-icon">{service.icon}</div>
                <div>
                  <div className="lp-search-bar-concierge-title">{service.label}</div>
                  {service.desc}
                </div>
              </ConciergeLink>
            ))}
          </div>
        )}
      </Modal>
    </>
  );
};

export default SearchBarConcierge;
